module.exports = __webpack_public_path__ + "img/attention.968947cb.png";